import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { useLevel1SectionData } from '../../hooks/useLevel1Section';

export const InteriorDamaged = () => {
  const { images } = useLevel1SectionData('interior_questions');

  const damagedImages = images.filter(img => img.is_damaged);
  if (damagedImages.length === 0) return <div style={{ flex: '1 1 200%' }} />;

  return (
    <Level2Wrapper flex="1 1 200%" label="Damage">
      <ImageList layoutSize="lg" label="Damage Pictures" images={damagedImages} />
    </Level2Wrapper>
  );
};
